/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface UpdateHookRequest
 */
export interface UpdateHookRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateHookRequest
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateHookRequest
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateHookRequest
     */
    externalServiceId?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateHookRequest
     */
    events?: Array<string>;
}

/**
 * Check if a given object implements the UpdateHookRequest interface.
 */
export function instanceOfUpdateHookRequest(value: object): boolean {
    return true;
}

export function UpdateHookRequestFromJSON(json: any): UpdateHookRequest {
    return UpdateHookRequestFromJSONTyped(json, false);
}

export function UpdateHookRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateHookRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'externalServiceId': json['externalServiceId'] == null ? undefined : json['externalServiceId'],
        'events': json['events'] == null ? undefined : json['events'],
    };
}

export function UpdateHookRequestToJSON(value?: UpdateHookRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'isEnabled': value['isEnabled'],
        'externalServiceId': value['externalServiceId'],
        'events': value['events'],
    };
}

